import { useEffect, useState } from "react";

export type CoachNotesState =
  | { status: "loading" }
  | { status: "ready"; title: string; bodyMarkdown: string }
  | { status: "empty" }
  | { status: "error"; message: string };

export function useCoachNotes(): CoachNotesState {
  const [state, setState] = useState<CoachNotesState>({ status: "loading" });

  useEffect(() => {
    let cancelled = false;
    setState({ status: "loading" });
    fetch("/api/coach-notes", { credentials: "same-origin" })
      .then(async (res) => {
        if (cancelled) return;
        if (res.status === 204) {
          setState({ status: "empty" });
          return;
        }
        if (!res.ok) {
          setState({ status: "error", message: `HTTP ${res.status}` });
          return;
        }
        const body = (await res.json()) as { title: string; bodyMarkdown: string };
        setState({ status: "ready", title: body.title, bodyMarkdown: body.bodyMarkdown });
      })
      .catch((err: unknown) => {
        if (cancelled) return;
        setState({
          status: "error",
          message: err instanceof Error ? err.message : String(err)
        });
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return state;
}
